import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { JobSourcing } from '../models/job-sourcing';
import { FinnAdvertisement } from '../../lib/classes/finn/finnAdvertisement';

@Injectable()
export class JobSourcingService {
  constructor(private http: HttpClient) {}

  private _apiEndpoint = environment.apiUrl;

  public getJobSourcing(jobId: number) {
    return this.http.get<JobSourcing>(
      `${this._apiEndpoint}sourcing/jobs/${jobId}/job-sourcing/`
    );
  }

  public updateJobSourcing(jobSourcing: JobSourcing) {
    const jobId = jobSourcing.job_id;
    return this.http.put<JobSourcing>(
      `${this._apiEndpoint}sourcing/jobs/${jobId}/job-sourcing/`,
      jobSourcing
    );
  }

  public purchaseJobSourcing(jobId: number) {
    return this.http.get<any>(
      `${this._apiEndpoint}sourcing/jobs/${jobId}/job-sourcing/purchase/`
    );
  }

  public postEquestJobBoard(jobId: number, boardId: number) {
    return this.http.post<any>(
      `${this._apiEndpoint}sourcing/jobs/${jobId}/job-sourcing/boards/${boardId}/post-equest/`,
      null
    );
  }

  public postFinnJobBoard(jobId: number, boardId: number) {
    return this.http.post<any>(
      `${this._apiEndpoint}sourcing/jobs/${jobId}/job-sourcing/boards/${boardId}/post-finn/`,
      null
    );
  }

  public recreateFinnJobBoard(boardId: number) {
    return this.http.get<FinnAdvertisement>(
      `${this._apiEndpoint}finn/job-boards/${boardId}/recreate-finn/`
    );
  }
}
